module.exports = __webpack_public_path__ + "img/avi.4d78429f.png";